import { render, staticRenderFns } from "./GovernanceEventView.vue?vue&type=template&id=c24f51b2&"
import script from "./GovernanceEventView.vue?vue&type=script&lang=js&"
export * from "./GovernanceEventView.vue?vue&type=script&lang=js&"
import style0 from "./GovernanceEventView.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports